import React from "react";
import { Link } from "react-router-dom";

const CTAPage = () => {
  return (
    <div className="bg-[#1d3a80] py-8 px-4">
      
      {/* SECTION HEADING */}
      <h2 className="text-[#FEFEFE] text-center text-3xl font-bold mb-8">
        Ready to Start?
      </h2>

      {/* INNER CONTAINER */}
      <div className="bg-[#FEFEFE] rounded-3xl p-6 max-w-6xl mx-auto">

        {/* MAIN CTA CARD */}
        <div className="bg-[#FEFEFE] border border-[#2670AA]/20 rounded-2xl p-8 text-center max-w-4xl mx-auto">

          {/* TITLE */}
          <h3 className="text-2xl sm:text-3xl font-bold text-[#861426] mb-3">
            Start Your Exam Preparation Today
          </h3>

          {/* SUBTITLE */}
          <p className="text-gray-600 max-w-2xl mx-auto mb-8">
            Structured courses, regular practice tests and expert guidance —
            everything you need to crack competitive exams with confidence.
          </p>

          {/* STATS */}
          <div className="grid grid-cols-3 gap-4 max-w-md mx-auto mb-8">
            <div className="rounded-lg border border-[#2670AA]/20 p-3">
              <div className="text-xl font-bold text-[#2670AA]">95%</div>
              <div className="text-xs text-gray-600">Success Rate</div>
            </div>
            <div className="rounded-lg border border-[#2670AA]/20 p-3">
              <div className="text-xl font-bold text-[#2670AA]">10K+</div>
              <div className="text-xs text-gray-600">Students</div>
            </div>
            <div className="rounded-lg border border-[#2670AA]/20 p-3">
              <div className="text-xl font-bold text-[#2670AA]">500+</div>
              <div className="text-xs text-gray-600">Mock Tests</div>
            </div>
          </div>

          {/* CTA BUTTONS */}
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/exams"
              className="bg-[#2670AA] hover:bg-[#1f5c8f]
                         text-[#FEFEFE] text-sm px-8 py-3 rounded-lg
                         transition font-medium"
            >
              Explore Courses
            </Link>

            <Link
              to="/demo-tests"
              className="bg-[#B02456] hover:bg-[#8e1c44]
                         text-[#FEFEFE] text-sm px-8 py-3 rounded-lg
                         transition font-medium"
            >
              Try Free Demo
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CTAPage;
